import DynamicTitleWithTooltip from "../components/DynamicTitleWithTooltip";
import Form from "./Form";
import { Edit as RaEdit } from "react-admin";
import React from "react";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";

const getAppSettingTitle = (record, translate) =>
  `${translate("app-setting.label")} ${record.id} (${record.key})`;

const Edit = (props) => {
  const id = props.id?.toString(); // ID della risorsa
  useManageOpenEditTabs(props.resource, id);

  return (
    <RaEdit
      {...props}
      title={<DynamicTitleWithTooltip getTitle={getAppSettingTitle} />}
    >
      <Form />
    </RaEdit>
  );
};
export default Edit;
